import { Component } from '@angular/core';

@Component({
  selector: 'app-users-icon',
  templateUrl: './users-icon.component.html',
})
export class UsersIconComponent {

}
